let count = 0;

/**
 * Utilitátio para geração de Ids.
 * Gera ids com um contador incremental, de modo que um Id nunca será repetido.
 * @param {String} [prefix] Prefixo para o Id. Opcional.
 * @returns {String}
 */
export function createId(prefix = '') {
  count += 1;
  return `${prefix}${count}`;
}

export function getUniqueId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
}
